<script setup lang="ts">
import { Star, Sparkles } from 'lucide-vue-next';
import { customersTestimonials } from '@app/types';
</script>

<template>
  <section class="border-y border-slate-200 bg-white py-8 sm:py-10">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <p class="text-xs sm:text-sm font-semibold text-slate-500 mb-6 uppercase tracking-wider">אין ספור שעות עבודה נחסכו עבור העסקים שלנו</p>
      <div class="flex flex-wrap justify-center items-center gap-6 sm:gap-8 md:gap-16 opacity-60 grayscale">
        <img v-for="testimonial of customersTestimonials" :src="testimonial.imgUrl" alt="" class="w-20">
      </div>
    </div>
  </section>
</template>
